import PropTypes from "prop-types"

const RegistrationButton = ({ children, buttonClass, modalUrl, onClick }) => {
  const buttonProps = {
    className: `sm ${buttonClass || "btn-outline"}`,
    ...(modalUrl && { "data-modal-url": modalUrl }),
    ...(onClick && { onClick })
  }

  return <button {...buttonProps}>{children}</button>
}

RegistrationButton.propTypes = {
  children: PropTypes.node,
  buttonClass: PropTypes.string,
  modalUrl: PropTypes.string,
  onClick: PropTypes.func
}

export default RegistrationButton
